import { RequestType, requestTypeNavigateParser } from "../../interfaces/Request";

export function redirectToEmptyDocumentFirstStep(
  documentType: RequestType,
  requestId: string,
) {
  switch (documentType) {
    case RequestType.PRESCRIPTION:
    case RequestType.MEDICAL_ORDER:
      return `/app/solicitudes/${requestId}/${requestTypeNavigateParser[documentType]}/crear/buscar`;
    default:
      return `/app/solicitudes/${requestId}/${requestTypeNavigateParser[documentType]}/crear`;
  }
}
